/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

import cleanUpResponse from '../util/cleanUpResponse';

export default async function GetUsersForRole(role) {
  const response = await $.soap({
    body: {
      GetUsersForRole: {
        $xmlns: 'http://TODO-URL/ems/common/bpm/user/1.0',
        Role: role
      }
    },
    blueprintArrays: ['GetUsersForRoleResponse.GetUsersForRoleResponse.tuple'],
    blueprint: {
      users: [
        '$..tuple',
        {
          userId: '$..cn.string',
          name: '$..description.string'
        }
      ]
    }
  });

  cleanUpResponse(response);
  const usersSorted = _.sortBy(response.users, ['name']);
  return usersSorted;
}
